<div class="colab-manager-content-component colab-autoupdate fade-in-animation">

    <div class="row" style="margin: 0;">
      <div class="col-md-12 col-sm-12 no-padding ">

        <h1 class="no-margin">Campanhas Especiais</h1>
        <p></p>
        <p>Os materiais estão disponíveis nos seguintes formatos: E-mail, Murais, TV Corporativas e com POST para comunicação interna.</p>
        <p>Todos contêm <strong>Arquivos editáveis</strong> (abertos para alterações) e <strong>Não editáveis</strong> (já prontos para sua utilização).</p>
        <div id="special-campaign" class="area-to-overlay">
          <h3 *ngIf="!isLoading"> Campanha Atual</h3>
          <div class="special-campaign-current" *ngIf="specialCampaigns && specialCampaigns.length">
            <img style="width: 77px" src="{{ specialCampaigns && specialCampaigns.length ? specialCampaigns[0]['image'] : ''}}" alt="" />
            <div class="text">
              <strong>{{ specialCampaigns && specialCampaigns.length ? specialCampaigns[0]['title'] : ''}}</strong>
              {{ specialCampaigns[0]['created_at'] | amDateFormat: 'MMMM Y' | titlecase }}
            </div>
            <div class="buttons">
              <button *ngIf="specialCampaigns[0].files.edited" class="btn-orange-contrast btn-editable btn-icon-text" (click)="trackingEvent(specialCampaigns[0].title, 'editable'); downloadFile(specialCampaigns[0].files.edited)">
                Editáveis
              </button>
              <button *ngIf="specialCampaigns[0].files.notEdited" class="btn-orange btn-non-editable btn-icon-text" (click)="trackingEvent(specialCampaigns[0].title, 'non-editable'); downloadFile(specialCampaigns[0].files.notEdited)">
                Não Editáveis
              </button>
            </div>
          </div>

          <small *ngIf="specialCampaigns && specialCampaigns.length === 0">Nenhuma campanha atual</small>

          <h3 *ngIf="!isLoading">Campanhas anteriores</h3>

          <table class="table table-striped">
            <tbody>
              <tr *ngFor="let campaign of specialCampaigns | slice:1; let i = index">
                <td><img style="width: 51px;" src="{{ campaign.image }}" /></td>
                <td><strong>{{ campaign.title }}</strong> {{ campaign.created_at | amDateFormat: 'MMMM Y' | titlecase }}</td>
                <td>
                  <button *ngIf="campaign.files.edited" class="btn-orange-contrast btn-editable" (click)="trackingEvent(campaign.title, 'editable'); downloadFile(campaign.files.edited)"></button>
                  <button *ngIf="campaign.files.notEdited" class="btn-orange btn-non-editable" (click)="trackingEvent(campaign.title, 'non-editable'); downloadFile(campaign.files.notEdited)"></button>
                </td>
              </tr>
            </tbody>
          </table>

          <small *ngIf="(specialCampaigns && specialCampaigns.length < 2) || (specialCampaigns && specialCampaigns.length === 0)">Nenhuma campanha anterior</small>

        </div>

        <div class="loading-overlay" *ngIf="isLoading">
            <div class="loader-wrp">
              <div class="loader"><span></span><span></span><span></span></div>
              <p> {{ 'LOADING' | translate }}</p>
            </div>
          </div>

      </div>
    </div>

</div>
